import Loadable from "components/Loadable";
import {lazy} from "react";
import AccountsBase from "../pages/accounts/AccountseBase";
import AssetseBase from "pages/accounts/assets/AssetseBase";
const AccountsDashboard = Loadable(lazy(() => import('pages/reports/accounting/ProfitLossMatrix')));
const PurchaseList = Loadable(lazy(() => import('pages/accounts/purchases/purchase')));
const AddPurchase = Loadable(lazy(() => import('pages/accounts/purchases/add-edit-purchase')));
const ViewPurchase = Loadable(lazy(() => import('pages/accounts/purchases/view-purchase')));
const InvoiceList = Loadable(lazy(() => import('pages/accounts/invoices/invoice')));
const AddInvoice = Loadable(lazy(() => import('pages/accounts/invoices/add-edit-invoice')));
const ViewInvoice = Loadable(lazy(() => import('pages/accounts/invoices/view-invoice')));
const Payment = Loadable(lazy(() => import('pages/project/job/payment/payment')));
const Expenses = Loadable(lazy(() => import('pages/accounts/expenses/expenses')));
const Vats = Loadable(lazy(() => import('pages/accounts/vat/vats')));
const Assets = Loadable(lazy(() => import('pages/accounts/assets/assets')));
const AddEditAsset = Loadable(lazy(() => import('pages/accounts/assets/add-edit-asset')));
const ViewAsset = Loadable(lazy(() => import('pages/accounts/assets/view-asset')));

const QuotationList = Loadable(lazy(() => import('pages/accounts/quotation/quotation-list')));
const AddQuotation = Loadable(lazy(() => import('pages/accounts/quotation/add-quotation')));
const ViewQuotation = Loadable(lazy(() => import('pages/accounts/quotation/view-quotation')));
const PrepareNDSendQuotation = Loadable(lazy(() => import('pages/accounts/quotation/prepare-send-quotation')));
const MakeInvoice = Loadable(lazy(() => import('pages/accounts/quotation/make-invoice')));

const PrepareNDSendInvoice = Loadable(lazy(() => import('pages/accounts/invoices/prepare-send-Invoice')));
const Accounts = {
    path: 'accounts',
    element: <AccountsBase />,
    children: [
        {
            path: '',
            element: <AccountsDashboard />
        },
        {
            path: 'quotation',
            // element: <QuotationList />,
            children:[
                {
                    path: '',
                    element: <QuotationList />
                },
                {
                    path: 'new-quotation',
                    element: <AddQuotation />
                },
                {
                    path: 'view-quotation/:id',
                    element: <ViewQuotation />
                },
                {
                    path: 'edit-quotation/:id',
                    element: <AddQuotation />
                },
                {
                    path: 'prepare-send/:id',
                    element: <PrepareNDSendQuotation />
                },
                {
                    path: 'make-invoice/:id',
                    element: <MakeInvoice />
                },
            ],
        },
        {
            path: 'invoices',
            // element: <QuotationList />,
            children:[
                {
                    path: '',
                    element: <InvoiceList />
                },
                {
                    path: 'new-invoice',
                    element: <AddInvoice />
                },
                {
                    path: 'view-invoice/:invoice_id',
                    element: <ViewInvoice />
                },
                {
                    path: 'edit-invoice/:invoice_id',
                    element: <AddInvoice />
                },
                {
                    path: 'prepare-send/:invoice_id',
                    element: <PrepareNDSendInvoice />
                },
                
            ],
        },
        {
            path: 'purchases',
            // element: <QuotationList />,
            children:[
                {
                    path: '',
                    element: <PurchaseList />
                },
                {
                    path: 'new-purchase',
                    element: <AddPurchase />
                },
                {
                    path: 'view-purchase/:id',
                    element: <ViewPurchase />
                },
                {
                    path: 'edit-purchase/:id',
                    element: <AddPurchase />
                },
             
        
            ],
        },
        {
            path: 'payments',
            // element: <QuotationList />,
            children:[
                {
                    path: '',
                    element: <Payment />
                },
                // {
                //     path: 'new-invoice',
                //     element: <AddInvoice />
                // },
                // {
                //     path: 'view-invoice/:id',
                //     element: <ViewInvoice />
                // },
                // {
                //     path: 'edit-invoice/:id',
                //     element: <AddInvoice />
                // },
            ],
        },
        {
            path:'expenses',
            element: <Expenses />
        },
        {
            path: 'vat',
            element: <Vats />
        },
        {
            path: 'assets',
            element: <AssetseBase />,
            children:[
               {
                path: '',
                element:  <Assets/>
               },
               {
                path: 'new-asset',
                element:  <AddEditAsset/>
               },
               {
                path: 'edit-asset/:asset_id',
                element:  <AddEditAsset/>
               },
               {
                path: 'view-asset/:asset_id',
                element:  <ViewAsset/>
               }
            ]
        },
    ]}
export default Accounts;
